































































































































import { Component, Vue } from 'vue-property-decorator';
import {i18n} from '../plugin/i18n';
import ButtonNextPage from '../components/ButtonNextPage.vue';
import ArticleSection from '../components/ArticleSection.vue';
import ArticleTop from '../components/ArticleTop.vue';
import ImageList from '../components/ImageList.vue';
import ArticleSectionImage from '../components/ArticleSectionImage.vue';
import Author from "../components/Author.vue";
import AuthorList from "../components/AuthorList.vue";
import Quote from "../components/Quote.vue";
import {Meta} from '../decorators/decorators';
import {Locales} from '../plugin/Locales';
import VideoPlayer from '../components/VideoPlayer.vue';
import LittleArticleCarrousel from '../components/LittleArticleCarrousel.vue';



@Component({
  components: {VideoPlayer, ArticleSectionImage, ImageList, ArticleTop, ArticleSection, ButtonNextPage, Author, AuthorList, Quote, LittleArticleCarrousel},
})
export default class KeyReport extends Vue {
  title: String = i18n.t('KeyReport.title') as string;
  subTitle: String = i18n.t('KeyReport.subTitle') as string;
  authorName: String = i18n.t('KeyReport.authorName') as string;
  quote001: String = i18n.t('KeyReport.quote001') as string;
  quote002: String = i18n.t('KeyReport.quote002') as string;
  encadreAuthorTitle: String = i18n.t('KeyReport.encadreAuthorTitle') as string;
  intro: String = i18n.t('KeyReport.intro') as string;
  contributors: any[] = i18n.t('KeyReport.contributors') as any;
  authors: any[] = i18n.t('KeyReport.authors') as any;
  contributorsTitle: String = i18n.t('KeyReport.contributorsTitle') as string;
  articles: any[] = i18n.t('KeyReport.articles') as any;

  @Meta
  myMetaConfig() {
    return {
      title:  i18n.t('KeyReport.title')
    }
  }

  mounted() {
  }
}
